import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Eye } from 'lucide-react';
import { BonusSection } from './BonusSection';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  const getDayName = () => {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    return days[new Date().getDay()];
  };
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <>
      <section className="py-8 bg-cream" data-id="element-81">
        <div className="max-w-md mx-auto px-6" data-id="element-82">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-6" data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/pve7QJMGfvcNADrQsLMnoB/Diseno_sin_titulo.png" alt="Los Secretos del Café Colombiano" className="w-full h-auto" data-id="element-84" />
          </motion.div>

          {/* Downloads & Title */}
          <p className="text-xs text-coffee/50 uppercase tracking-wider mb-1" data-id="element-85">
            +1.200 descargas
          </p>
          <h2 className="text-xl md:text-2xl font-serif text-coffee-dark mb-3" data-id="element-86">
            La Biblia del Café: La Guía Definitiva
          </h2>

          {/* Pricing */}
          <div className="flex items-baseline gap-3 mb-2" data-id="element-87">
            <span className="text-base text-coffee/40 line-through" data-id="element-88">
              $29.999
            </span>
            <span className="text-2xl font-bold text-coffee-dark" data-id="element-89">
              $14.999 ARS
            </span>
          </div>

          {/* Offer Banner */}
          <div className="inline-flex items-center gap-2 bg-coffee-light/20 text-coffee-dark px-3 py-1.5 rounded-full text-xs font-medium mb-2" data-id="element-90">
            <span data-id="element-91">🔥</span>
            <span data-id="element-92">Oferta -50% OFF (Solo 10 cupos)</span>
          </div>

          <p className="text-xs text-coffee/50 mb-2" data-id="element-93">Impuestos incluidos.</p>

          {/* Urgency */}
          <div className="flex items-center gap-2 mb-4" data-id="element-94">
            <span className="relative flex h-2 w-2" data-id="element-95">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-96"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-97"></span>
            </span>
            <span className="text-coffee-dark text-sm" data-id="element-98">
              ⚡ ¡Últimos{' '}
              <span className="font-bold text-red-500" data-id="element-99">3 Cupos</span> en Oferta!
            </span>
          </div>

          {/* CTA Button */}
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-coffee-dark hover:bg-coffee-dark/90 text-cream font-semibold py-3 px-6 rounded-lg flex items-center justify-center gap-2 transition-colors mb-4" data-id="element-100">
            <ShoppingCart className="w-4 h-4" data-id="element-101" />
            <span data-id="element-102">Agregar al carrito</span>
          </motion.button>

          {/* Viewers */}
          <div className="flex items-center justify-center gap-2 text-coffee/70 mb-4" data-id="element-103">
            <Eye className="w-4 h-4" data-id="element-104" />
            <span className="text-xs" data-id="element-105">
              <span className="font-semibold text-coffee-dark" data-id="element-106">
                33 personas
              </span>{' '}
              están viendo
            </span>
          </div>

          {/* Timer Box */}
          <div className="bg-white rounded-xl p-4 text-center shadow-sm border border-coffee-light/20" data-id="element-107">
            <h3 className="text-sm font-serif font-semibold text-coffee-dark mb-1" data-id="element-108">
              ¡Oferta solo por hoy {getDayName()}!
            </h3>
            <p className="text-xs text-coffee/60 mb-3" data-id="element-109">
              Tu lugar estará reservado por{' '}
              <span className="font-semibold" data-id="element-110">15 minutos</span>
            </p>

            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-111">
              <div className="bg-coffee-dark rounded-lg px-3 py-1.5" data-id="element-112">
                <span className="text-xl font-bold text-cream" data-id="element-113">
                  {String(minutes).padStart(2, '0')}
                </span>
                <p className="text-[8px] uppercase tracking-wider text-cream/50" data-id="element-114">
                  Min
                </p>
              </div>
              <span className="text-lg font-bold text-coffee-dark" data-id="element-115">:</span>
              <div className="bg-coffee-dark rounded-lg px-3 py-1.5" data-id="element-116">
                <span className="text-xl font-bold text-cream" data-id="element-117">
                  {String(seconds).padStart(2, '0')}
                </span>
                <p className="text-[8px] uppercase tracking-wider text-cream/50" data-id="element-118">
                  Seg
                </p>
              </div>
            </div>

            <div className="bg-coffee-light text-white text-xs font-medium py-2 px-4 rounded-lg" data-id="element-119">
              Hoy 50% descuento + BONOS de regalo
            </div>
          </div>

          {/* Payment Trust Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-4" data-id="element-120">
            <img src="https://cdn.magicpatterns.com/uploads/4Nq5iMynURQMSKADEsH8x7/LANDING_HERRERO_f5bba779-7bf3-40b5-8293-cbf03b43d551.png" alt="Pago seguro garantizado - MercadoLíder Platinum" className="w-full h-auto" data-id="element-121" />
          </motion.div>
        </div>
      </section>

      {/* Bonus Section */}
      <BonusSection data-id="element-122" />
    </>;
}